import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryBricksRequired extends AnnualSummaryError {
    constructor(options) {
        super('The number of bricks is not sent without promotional coupon', options);
    }
}
export default AnnualSummaryBricksRequired;
